
.container {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  align-items: center;
  justify-content: center;
  height: 100vh;
  overflow: auto;
}

.modalHeader {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0;
  align-self: stretch;

  background: linear-gradient(180deg, #feedde 17.71%, rgba(250, 250, 250, 0) 100%);
}

.modalBody {
  display: flex;
  padding: 0 2rem 2rem 2rem;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  align-self: stretch;
  overflow: auto;
}

.checklistItem {
  display: flex;
  align-items: center;
  gap: 0.75rem;

  color: var(--primary-enabled, #ff5823);
}
